<template>
	<div class="machine-group">
		<search-user-machine-group
			v-on:addUserMachineGroup="addUserGroupTransfer"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		></search-user-machine-group>
		<add-user-group-transfer
			v-on:cancel="cancel"
			:userGroupTransfer="userGroupTransfer"
			:dialogUserGroupTransfer="dialogUserGroupTransfer"
		></add-user-group-transfer>
		<move-user-machine-group
			v-on:moveUserMachineGroupCancel="moveUserMachineGroupCancel"
			:teamId="teamId"
			:dialogMoveUserMachineGroup="dialogMoveUserMachineGroup"
		>
		</move-user-machine-group>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="userGroupTransferList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="nickName"
					:show-overflow-tooltip="true"
					:label="$t('userMachineGroup.nickName')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="name"
					:label="$t('userMachineGroup.name')"
					:show-overflow-tooltip="true"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 150 : 155"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button size="mini" @click="editGroupTransfer(scope.row)">{{
							$t("common.edit")
						}}</el-button>
						<el-button
							type="danger"
							icon="el-icon-delete"
							size="mini"
							@click="handleDelGroup(scope.row)"
							style="padding: 7px;"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchUserMachineGroup from "_c/machine/user/SearchUserMachineGroup";
import addUserGroupTransfer from "_c/machine/user/AddUserGroupTransfer";
import moveUserMachineGroup from "_c/machine/user/MoveUserMachineGroup";
export default {
	name: "MachineGroup",
	components: {
		moveUserMachineGroup,
		addUserGroupTransfer,
		searchUserMachineGroup,
	},
	data() {
		return {
			//  转移分组列表
			search: {
				userName: "",
				name: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			userGroupTransferList: [],
			//  转移分组添加弹窗
			dialogUserGroupTransfer: false,
			userGroupTransfer: {
				id: "",
				name: "",
				userMachineId: [],
			},
			loading: false,
			dialogMoveUserMachineGroup: false,
			portSet: [],
			baudSet: [],
			modeList: [],
			yesNo: [],
			ageDevice: [],
			ageType: [],
			priorityMode: [],
			dialogConfigMachine: false,
			configSubmit: {
				id: "",
				port: "",
				baud: "",
				isPAd: 0,
				isTAd: 0,
				isLang: 0,
				isPTag: 0,
				machineMode: "",
				tipTitle: "",
				tipMessage: "",
				tipConfirm: "",
				tipCancel: "",
				password: "",
				tipPassword: "",
				isDebug: "",
				isSms: "",
				isTip: "",
				isShoppingTip: "",
				shoppingTipTitle: "",
				shoppingTipMessage: "",
				shoppingTipConfirm: "",
				shoppingTipCancel: "",
				cartNum: "",
				faceSimilarity: "",
				ageCount: "",
				isCart: "",
				isRemoteControl: "",
				isDoubleScreen: "",
				isFace: "",
				isPrivacy: "",
				privacy: "",
				isAge: "",
				isCoupon: "",
				isAgeDevice: "",
				isAgeType: "",
				isAgeCamera: "",
				isAgeCode: "",
				isAgeFace: "",
				isAgePriority: "",
				certImg: "",
				cert: [],
				userMachineLang: [],
				isClose: "",
				lockSwitch: "",
			},
			teamId: "",
			IdcardCountry: [],
		};
	},
	mounted() {
		this.currentChange();
		this.getIdcardCountry();
		this.getYesNo();
		this.machineMode();
		this.getPort();
		this.getBaud();
		this.getAgeDevice();
		this.getAgeType();
		this.getPriorityMode();
	},
	methods: {
		getAgeDevice() {
			this.$api.dict("age_device").then(res => {
				if (res.code === 0) {
					this.ageDevice = res.data;
				}
			});
		},
		getAgeType() {
			this.$api.dict("age_discern_type").then(res => {
				if (res.code === 0) {
					this.ageType = res.data;
				}
			});
		},
		getPriorityMode() {
			this.$api.dict("priority_mode").then(res => {
				if (res.code === 0) {
					this.priorityMode = res.data;
				}
			});
		},
		getIdcardCountry() {
			this.$api.dict("sys_idcard_country").then(res => {
				if (res.code === 0) {
					this.IdcardCountry = res.data;
				}
			});
		},
		configCancel(dialog, state) {
			this.dialogConfigMachine = dialog;
			if (state) {
				this.currentChange();
			}
		},
		//  当前在转移分组
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(
					this.$url.UserMachineGroup.userMoveGroup,
					this.$method.get,
					obj
				)
				.then(res => {
					if (res.code === 0) {
						this.userGroupTransferList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleDelGroup(row) {
			let _self = this;
			_self
				.$confirm(
					_self.$t("grouptransfer.delwarn"),
					_self.$t("common.warning"),
					{
						confirmButtonText: _self.$t("common.definite"),
						cancelButtonText: _self.$t("common.cancel"),
						type: "warning",
					}
				)
				.then(() => {
					_self.$api
						.request(_self.$url.Grouptransfer.delete, _self.$method.delete, {
							id: row.id,
						})
						.then(res => {
							if (res.code === 0) {
								_self.$notify({
									title: _self.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								_self.currentChange();
							}
						});
				});
		},
		machineMode() {
			this.$api.dict("gp_user_machine_mode").then(res => {
				this.modeList = res.data;
			});
		},
		getYesNo() {
			this.$api.dict("sys_yes_no").then(res => {
				if (res.code === 0) {
					this.yesNo = res.data;
				}
			});
		},
		getPort() {
			this.$api.dict("sys_app_type").then(res => {
				if (res.code === 0) {
					this.portSet = res.data;
				}
			});
		},
		getBaud() {
			this.$api.dict("sys_baud_type").then(res => {
				if (res.code === 0) {
					this.baudSet = res.data;
				}
			});
		},
		//  添加按钮
		addUserGroupTransfer() {
			this.userGroupTransfer.id = "";
			this.dialogUserGroupTransfer = true;
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		cancel(dialog, state) {
			this.dialogUserGroupTransfer = dialog;
			this.userGroupTransfer.id = 0;
			this.userGroupTransfer.name = "";
			this.userGroupTransfer.userMachineId = [];
			if (state) {
				this.currentChange();
			}
		},
		//  编辑按钮
		editGroupTransfer(row) {
			Object.keys(this.userGroupTransfer).forEach(key => {
				this.userGroupTransfer[key] = row[key];
			});
			this.userGroupTransfer.id = row.id;
			delete this.userGroupTransfer.userMachineId;
			this.dialogUserGroupTransfer = true;
		},
		transferMachine(row) {
			this.dialogMoveUserMachineGroup = true;
			this.teamId = row.id;
		},
		moveUserMachineGroupCancel(dialog) {
			this.dialogMoveUserMachineGroup = dialog;
		},
	},
};
</script>

<style>
.el-dialog__header {
	padding: 20px 20px 10px 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
